<template>
  <div class="buyerShop">
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane v-if="basicInfoBtn" :label="$t('crm.basicInfo')" name="basicInfo"></el-tab-pane>
      <el-tab-pane v-if="paymentBtn" :label="$t('crm.payment')" name="payment"></el-tab-pane>
      <el-tab-pane v-if="vendorContactsBtn" :label="$t('crm.vendorContactsInfo')" name="vendorContacts"></el-tab-pane>
      <el-tab-pane v-if="imBusinessStatusBtn" :label="$t('crm.imBusinessStatus')" name="imBusinessStatus"></el-tab-pane>
      <!-- <el-tab-pane :label="$t('crm.imBusinessStatus')" name="imBusinessStatus"></el-tab-pane> -->
      <el-tab-pane v-if="otherSaleChannelInfoBtn" :label="$t('crm.otherSaleChannelInfo')" name="otherSaleChannelInfo"></el-tab-pane>
      <el-tab-pane v-if="fulfillmentBtn" :label="$t('crm.fulfillment')" name="fulfillment"></el-tab-pane>
      <el-tab-pane v-if="vendorEventParticipationBtn" :label="$t('crm.vendorEventParticipation')" name="vendorEventParticipation"></el-tab-pane>
      <!-- <el-tab-pane :label="$t('crm.vendorStockStatus')" name="vendorStockStatus"></el-tab-pane> -->
      <el-tab-pane v-if="shipmentStockLocationInfoBtn" :label="$t('crm.shipmentStockLocationInfo')" name="shipmentStockLocationInfo"></el-tab-pane>
      <el-tab-pane v-if='goodsInfoBtn' :label="$t('crm.goodsInfo')" name="goodsInfo"></el-tab-pane>
      <el-tab-pane v-if='workLogBtn' :label="$t('crm.workLog')" name="workLog"></el-tab-pane>
    </el-tabs>

    <basic-info v-if="activeTab === 'basicInfo'"></basic-info>
    <payment v-if="activeTab === 'payment'"></payment>
    <vendor-contacts v-if="activeTab === 'vendorContacts'"></vendor-contacts>
    <im-business-status  v-if="activeTab === 'imBusinessStatus'"></im-business-status>
    <other-sale-channel-info v-if="activeTab === 'otherSaleChannelInfo'"></other-sale-channel-info>
    <fulfillment v-if="activeTab === 'fulfillment'"></fulfillment>
    <vendor-event-participation v-if="activeTab === 'vendorEventParticipation'"></vendor-event-participation>
    <!-- <vendor-stock-status v-if="activeTab === 'vendorStockStatus'"></vendor-stock-status> -->
    <shipment-stock-location-info v-if="activeTab === 'shipmentStockLocationInfo'"></shipment-stock-location-info>
    <goods-info v-if="activeTab === 'goodsInfo'"></goods-info>
    <work-log v-if="activeTab === 'workLog'"></work-log>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getVendorList } from './api';
import BasicInfo from './tabs/basicInfo.vue';
import Payment from './tabs/payment.vue';
import VendorContacts from './tabs/vendorContacts.vue';
import ImBusinessStatus from './tabs/imBusinessStatus.vue';
import OtherSaleChannelInfo from './tabs/otherSaleChannelInfo.vue';
import Fulfillment from './tabs/fulfillment.vue';
import VendorEventParticipation from './tabs/vendorEventParticipation.vue';
import VendorStockStatus from './tabs/vendorStockStatus.vue';
import ShipmentStockLocationInfo from './tabs/shipmentStockLocationInfo.vue';
import GoodsInfo from './tabs/goodsInfo.vue';
import WorkLog from './tabs/workLog.vue';

function checkPermission(list, code) {
  if (!list) {
    return false;
  }
  for (let i = 0; i < list.length; i++) {
    const menu = list[i];
    if (menu.code.endsWith('商家CRM')) {
      for (let j = 0; j < menu.children.length; j++) {
        const sub = menu.children[j];
        if (sub.code === code) {
          return true;
        }
      }
    }
  }
  return false;
}

export default {
  components: {
    BasicInfo,
    Payment,
    VendorContacts,
    ImBusinessStatus,
    OtherSaleChannelInfo,
    Fulfillment,
    VendorEventParticipation,
    VendorStockStatus,
    ShipmentStockLocationInfo,
    GoodsInfo,
    WorkLog,
  },
  data() {
    return {
      activeTab: 'basicInfo',
    };
  },
  computed: mapState({
    basicInfoBtn: (state) => checkPermission(state.app.menuList, 'hide-查看基本信息'),
    paymentBtn: (state) => checkPermission(state.app.menuList, 'hide-查看支付信息'),
    vendorContactsBtn: (state) => checkPermission(state.app.menuList, 'hide-查看商家联络信息'),
    otherSaleChannelInfoBtn: (state) => checkPermission(state.app.menuList, 'hide-查看其他业务渠道'),
    imBusinessStatusBtn: (state) => checkPermission(state.app.menuList, 'hide-查看IM业务'),
    shipmentStockLocationInfoBtn: (state) => checkPermission(state.app.menuList, 'hide-查看物流&发货地信息'),
    imBusinessStatusBtn: (state) => checkPermission(state.app.menuList, 'hide-IM业务'),
    fulfillmentBtn: (state) => checkPermission(state.app.menuList, 'hide-查看履约信息'),
    goodsInfoBtn: (state) => checkPermission(state.app.menuList, 'hide-查看货品信息'),
    vendorEventParticipationBtn: (state) => checkPermission(state.app.menuList, 'hide-查看活动情况'),
    workLogBtn: (state) => checkPermission(state.app.menuList, 'hide-查看工作日志'),
  }),
  mounted() {
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="less" scoped>
.buyerShop {
  padding: 20px;
}
.form-btn {
  margin-top: 40px;
}
.mt10 {
  margin-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.tr {
  text-align: right;
}
</style>
